import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    num: "01",
    title: "A shop born in 1999",
    text: "Long before online florists, Utsav Flowers opened its shutters at Kusum Hotel Complex, Talkie House Road with a basket of marigolds and a promise — no flower leaves the shop unless we would gift it ourselves.",
  },
  {
    num: "02",
    title: "Décor for life's big days",
    text: "Weddings, engagements, birthdays, corporate gatherings — for twenty-six years the families of Dibrugarh have trusted us to dress their most important days in flowers.",
  },
];

export default function Manifesto() {
  return (
    <section id="story" data-testid="manifesto-section" className="bg-cream py-28 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-16 text-xs font-bold uppercase tracking-[0.3em] text-sage"
        >
          Our Story — In Two Chapters
        </motion.p>

        <div>
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
              className="grid grid-cols-1 gap-6 border-t border-forest/15 py-14 md:grid-cols-12 md:gap-10"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="md:col-span-2">
                <span className="font-serif text-5xl italic text-marigold md:text-6xl">{c.num}</span>
              </div>
              <h3 className="font-serif text-3xl font-medium tracking-tight text-forest md:col-span-4 md:text-5xl">
                {c.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-sage md:col-span-6 md:text-lg">
                {c.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
